function buildPage(pageType) {
    return {
        '@id': `sdrn:subito:page:${pageType}`,
        '@type': 'Page',
        pageType,
    };
}
function buildTarget(pageType) {
    return {
        id: pageType,
        type: 'Page',
        pageType,
    };
}
function buildSearchSubmitEvent(geo, label, rank, isRecentSearch = false) {
    const dataLayer = window?.subito?.dataLayer;
    const pageType = dataLayer?.page?.getPageType?.();
    return {
        type: 'Click',
        object: {
            id: isRecentSearch
                ? 'geo-search-recent-searches'
                : 'geo-search-dropdown-result',
            name: isRecentSearch
                ? 'GeoSearchRecentSearches'
                : 'GeoSearchDropdownResult',
            type: 'UIElement',
            elementType: 'Li',
            label,
            'spt:custom': {
                rank,
                geo,
            },
        },
        page: buildPage(pageType),
        target: buildTarget(pageType),
    };
}
function buildSearchCancelEvent() {
    const dataLayer = window?.subito?.dataLayer;
    const pageType = dataLayer?.page?.getPageType?.();
    return {
        type: 'Click',
        object: {
            id: 'geo-search-cancel',
            name: 'GeoSearchCancel',
            type: 'UIElement',
        },
        page: buildPage(pageType),
        target: buildTarget(pageType),
    };
}
function buildRadiusSearchInitiateEvent({ label }) {
    return {
        type: 'Click',
        intent: 'Open',
        object: {
            type: 'UIElement',
            id: 'radiussearch:element:open',
            name: 'GeoSearchOpen',
            action: 'Click UIElement',
            elementType: 'Button',
            label,
            position: 'Top',
            size: 'small',
        },
        page: buildPage('listing'),
        target: buildTarget('listing'),
    };
}
function buildRadiusSearchCancelEvent() {
    return {
        type: 'Click',
        intent: 'Close',
        object: {
            id: 'radiussearch:element:dismiss',
            type: 'UIElement',
            action: 'Click UIElement',
            elementType: 'Button',
            label: 'X',
            position: 'Top',
        },
        page: buildPage('listing'),
        target: buildTarget('listing'),
    };
}

export { buildRadiusSearchCancelEvent, buildRadiusSearchInitiateEvent, buildSearchCancelEvent, buildSearchSubmitEvent };
//# sourceMappingURL=tracking.js.map
